export default __webpack_public_path__ + "static/man-and-women-daca9816b895fb57ea5e9d7816148b75.png";